<template>
  <basic-container v-loading="pageLoading">
    <!-- 搜索 -->
    <avue-form ref="searchForm" v-model="searchForm" :option="searchFromOption">
      <template slot="warehouseId">
        <el-select v-model="searchForm.warehouseId" placeholder="仓库名称">
          <el-option
            v-for="item in warehouseList1"
            :key="item.id"
            :label="item.name"
            :value="item.id"
            :disabled="item.status == 0"
          >
          </el-option>
        </el-select>
      </template>
      <template slot="menuForm">
        <div >
          <el-button size="small" icon="el-icon-search" type="primary" @click="searchSubmit">
            搜 索
          </el-button>
          <el-button size="small" icon="el-icon-delete" @click="searchClear">重 置</el-button>
        </div>
      </template>
    </avue-form>
    <!-- 表格 -->
    <avue-crud
      ref="crud"
      :option="crudOption"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" @click="addCheckTask">
          新增临时盘点任务
        </el-button>
      </template>
      <template slot-scope="scope" slot="menu">
        <el-button type="text" size="small" @click="viewDetail(scope.row)">
          查看
        </el-button>
      </template>
    </avue-crud>
    <!-- 新增弹窗 -->
    <el-dialog
      title="临时盘点单"
      :visible.sync="addDialogVisible"
      append-to-body
      width="65%"
      :fullscreen="dialogFull"
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :before-close="handleClose"
    >
    <template slot="title">
                        <div class="avue-crud__dialog__header">
                                <span class="el-dialog__title">
                                        临时盘点单
                                </span>
                                <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                                
                        </div>
                        <el-divider></el-divider>
                </template>
      <avue-form ref="addForm" v-model="addForm" :option="addFormOption" v-if="addDialogVisible">
        <template slot="warehouseId">
          <el-select
            v-model="addForm.warehouseId"
            placeholder="请选择仓库"
            :disabled="mode == 'edit' || mode == 'view'"
          >
            <el-option
              v-for="item in warehouseList2"
              :key="item.id"
              :label="item.name"
              :value="item.id"
              :disabled="item.status == 0"
            >
            </el-option>
          </el-select>
        </template>
      </avue-form>
      <div style="display: flex; justify-content: center">
        <el-button
          type="primary"
          size="small"
          @click="startCheck"
          style="margin-right: 20px"
          >开始盘点
        </el-button>
        <el-button size="small" @click="handleClose"
          >返回</el-button
        >
      </div>
    </el-dialog>
    <!-- 详情弹窗 -->
    <el-dialog
      :visible.sync="detailDialogVisible"
      append-to-body
      width="90%"
      @close="detailDialogColse"
    >
      <Detail
        v-if="detailDialogVisible"
        :id="taskId"
        :dicts="taskDicts"
        @taskSubmit="taskSubmit"
      />
    </el-dialog>
  </basic-container>
</template>

<script>
import {
  getProjectList,
  getWarehouseList,
  getBusinessNo,
} from "@/api/crmedical/warehouse/index.js";
import {
  createTemporaryTask,
  checkPage,
} from "@/api/crmedical/warehouse/check-task.js";

import Detail from "./detail";

export default {
  components: { Detail },
  computed: {
    searchFromOption() {
      return {
        size: "small",
        submitBtn: false,
        emptyBtn: false,
        menuPosition:'right',
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            placeholder:"项目名称",
            span: 6,
            clearable: false,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
            rules: [{ required: true, message: "请选择项目" }],
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            placeholder:"仓库名称",
            clearable: false,
            formslot: true,
            span: 6,
            props: {
              label: "name",
              value: "id",
            },
            rules: [{ required: true, message: "请选择仓库" }],
          },
          {
            label: "盘点类型",
            prop: "type",
            type: "select",
            placeholder:"盘点类型",
            clearable: false,
            span: 6,
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicUrl:
              "/api/blade-system/dict/dictionary?code=warehouse_check_task_type",
          },
          {
            label: "盘点批次号",
            prop: "code",
            maxlength: 30,
            placeholder:"盘点批次号",
            span: 6,
          },
        ],
      };
    },
    addFormOption() {
      return {
        size: "small",
        emptyBtn: false,
        submitBtn: false,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            clearable: false,
            span: 8,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
            rules: [{ required: true, message: "请选择项目" }],
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            clearable: false,
            span: 8,
            formslot: true,
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList2,
            rules: [{ required: true, message: "请选择仓库" }],
          },
          {
            label: "盘点单号",
            prop: "code",
            span: 8,
            disabled: true,
            rules: [{ required: true, message: "" }],
          },
          {
            label: "备注",
            prop: "description",
            type: "textarea",
            span: 24,
            maxlength: 300,
            showWordLimit: true,
          },
        ],
      };
    },
    crudOption() {
      return {
        addBtn: false,
        delBtn: false,
        editBtn: false,
        index: true,
        menuWidth: 120,
        border:true,
        height:this.bodyHeight - 380,
        stripe:true,
        column: [
          {
            label: "项目名称",
            prop: "projectId",
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.projectList,
          },
          {
            label: "任务名称",
            prop: "name",
            span: 6,
          },
          {
            label: "仓库名称",
            prop: "warehouseId",
            type: "select",
            props: {
              label: "name",
              value: "id",
            },
            dicData: this.warehouseList1,
          },
          {
            label: "盘点批次单号",
            prop: "code",
          },
          {
            label: "盘点类型",
            prop: "type",
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicUrl:
              "/api/blade-system/dict/dictionary?code=warehouse_check_task_type",
          },
          {
            label: "盘点开始时间",
            prop: "checkStartTime",
          },
          {
            label: "盘点结束时间",
            prop: "checkEndTime",
          },
          {
            label: "状态",
            prop: "workStatus",
            type: "select",
            props: {
              label: "dictValue",
              value: "dictKey",
            },
            dicUrl:
              "/api/blade-system/dict/dictionary?code=warehouse_check_task_work_status",
          },
          {
            label: "盈亏",
            prop: "result",
          },
        ],
      };
    },
  },
  watch: {
    "searchForm.projectId"(val) {
      if (!val || this.initLoad) return;
      getWarehouseList({
        projectId: val,
      }).then(({ data }) => {
        console.log("data==>", data);
        this.warehouseList1 = data;
        let first = this.warehouseList1.find((ele) => ele.status === 1);
        this.searchForm.warehouseId = first ? first.id : "";
        this.loadList();
      });
    },
    "addForm.projectId"(val) {
      if (!val) return;
      getWarehouseList({
        projectId: val,
      }).then(({ data }) => {
        this.warehouseList2 = data;
        let first = this.warehouseList2.find((ele) => ele.status == 1);
        this.addForm.warehouseId = first ? first.id : "";
      });
    },
  },
  data() {
    return {
      dialogFull:false,
      passCloseDialog:false,
      initLoad: true, //是否第一次加载
      data: [], //主数据
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      pageLoading: false,
      //表格
      projectList: [],
      warehouseList1: [],
      searchForm: {
        projectId: "",
        warehouseId: "",
        type: "",
        code: "",
      },
      //新增
      addDialogVisible: false,
      warehouseList2: [],
      addForm: {
        projectId: "",
        warehouseId: "",
        code: "",
        description: "",
      },
      //详情
      detailDialogVisible: false,
      taskId: "",
      taskDicts: {},
    };
  },
  created() {
    this.fetchData();
  },
  methods: {
    handleClose(done){
                        let self = this;
                        if(this.passCloseDialog){
                                self.addDialogVisible = false;
                                return;
                        }
                        this.$confirm('确认关闭?', '提示', {
                                confirmButtonText: '确定',
                                cancelButtonText: '取消',
                                type: 'warning',
                        })
                        .then(()=> {
                                
                                        self.addDialogVisible = false;
                               
                                        // done();
                        })
                        .catch(()=> {
                                
                        });
                },
    async addCheckTask() {
      this.pageLoading = true;
      try {
        this.addForm.projectId = this.searchForm.projectId;
        this.addForm.description = "";
        let { data } = await getBusinessNo({ businessType: 5 });
        this.addForm.code = data;
        this.addDialogVisible = true;
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    startCheck() {
      this.$refs['addForm'].validate((valid) => {
        if (valid) {
          this.$confirm('是否开始盘点?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(() => createTemporaryTask(this.addForm))
            .then(({ data }) => {
              this.taskId = data;
              this.taskDicts = {
                projectList: this.projectList,
                warehouseList: this.warehouseList1,
              };
              this.addDialogVisible = false;
              this.detailDialogVisible = true;
            })
            .catch((err) => {
              console.log('err==>', err);
              err == 'cancel' && this.$message.info('已取消');
            });
        }
      });
    },
    async viewDetail(data) {
      console.log("data==>", data);
      this.taskId = data.id;
      this.taskDicts = {
        projectList: this.projectList,
        warehouseList: this.warehouseList1,
      };
      this.detailDialogVisible = true;
    },
    detailDialogColse() {
      this.loadList();
      this.detailDialogVisible = false;
    },
    taskSubmit(data) {
      this.detailDialogColse();
      this.$nextTick(() => {
        this.viewDetail(data);
      });
    },
    searchClear() {
      this.searchForm.type = "";
      this.searchForm.code = "";
      this.loadList();
    },
    searchSubmit() {
      this.loadList();
    },
    async fetchData() {
      this.pageLoading = true;
      try {
        let res1 = await getProjectList();
        this.projectList = res1.data;
        this.searchForm.projectId = this.projectList[0]
          ? this.projectList[0].id
          : "";
        let res2 = await getWarehouseList({
          projectId: this.searchForm.projectId,
        });
        this.warehouseList1 = res2.data;
        let first = this.warehouseList1.find((ele) => ele.status == 1);
        this.searchForm.warehouseId = first ? first.id : "";
        this.loadList();
        this.initLoad = false;
      } catch (err) {
        console.log("err==>", err);
      }
      this.pageLoading = false;
    },
    sizeChange(pageSize) {
      this.page.pageSize = pageSize;
      this.loadList();
    },
    currentChange(current) {
      this.page.current = current;
      this.loadList();
    },
    loadList() {
      this.pageLoading = true;
      let params = this.searchForm;
      params.current = this.page.currentPage;
      params.size = this.page.pageSize;
      checkPage(params)
        .then(({ data: { records, current, total } }) => {
          console.log("records==>", records);
          records.forEach((element) => {
            element.type += "";
            element.workStatus += "";
            switch (element.checkResult) {
              case null:
                element.result = "";
                break;
              case undefined:
                element.result = "";
                break;
              case 0:
                element.result = "/";
                break;
              default:
                element.result = (
                  element.checkResult * element.resultAmount
                ).toFixed(2);
            }
          });
          this.pageLoading = false;
          this.data = records;
          this.page.currentPage = current;
          this.page.total = total;
        })
        .catch((err) => {
          console.log("err==>", err);
          this.pageLoading = false;
        });
    },
  },
};
</script>